<template>
  <div class="print-exchange  comm-note">
    <div>
      <el-button
        type="primary"
        style="position: fixed; top: 15px; right: 460px; font-size: 18px"
        @click="saveHandler"
        v-show="mode != 'mobile'"
        v-loading="buttonLoad"
        >保存</el-button
      >
      <el-button
        type="warning"
        style="position: fixed; top: 15px; right: 330px; font-size: 18px"
        @click="printHandler"
        v-show="mode != 'mobile'"
        >打印</el-button
      >
    </div>
    <div id="print">
      <template v-for="(item, index) in info">
        <div
          :key="item.renewalId"
          style="
            width: 21cm;
            margin: 2cm auto auto auto;
            min-height: 28cm;
            padding: 0 1.5cm;
            box-sizing: border-box;
          "
        >
          <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
            <span
              style="color: #ff0000;font-family: 华文中宋;font-size: 32pt;
                font-weight: bold;letter-spacing: 9pt;text-decoration: none;"
              >中国化学工程集团有限公司</span
            >
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
            <span
              style="color: #ff0000;font-family: Times New Roman;font-size: 13pt;font-weight:bold;letter-spacing: 2pt;text-decoration: none;"
            >
              CHINA NATIONAL CHEMICAL ENGINEERING GROUP CO., LTD.
            </span>
          </p>
          <div
            style="border-bottom: 1pt solid #000; margin: 10pt 0 10pt 4pt"
          ></div>
          <p
            style="
              margin: 13pt 0pt 7.8pt;
              orphans: 0;
              text-align: right;
              widows: 0;
            "
          >
            <span style="font-family: 仿宋; font-size: 14pt">{{
              item.receiveNo
            }}</span>
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: center; widows: 0">
            <span style="font-family: 宋体; font-size: 18pt; font-weight: bold"
              >关于申请常驻人员境外</span
            >
            <span style="font-family: 宋体; font-size: 18pt; font-weight: bold"
              >{{
                item.type == 1
                  ? "换发护照"
                  : item.type == 2
                  ? "补发护照"
                  : "申请旅行证"
              }}的函</span
            >
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
            <span style="font-family: 宋体; font-size: 14pt; font-weight: bold"
              >&#xa0;</span
            >
          </p>
          <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
            <span style="font-family: 宋体; font-size: 14pt; font-weight: bold"
              >外交部领事司：</span
            >
          </p>
          <div
            class="show-content"
            v-if="isContent"
            style="
              margin: 0pt;
              text-align: justify;
              text-indent: 21pt;
              line-height:28pt;
              widows: 0;
              font-family: 宋体;
              overflow: hidden;
              font-size: 14pt;
            "
            contenteditable
          >
            <span>{{ item.letterContent }}</span>
          </div>
          <div
            class="letter-content"
            v-if="!isContent"
            style="
              margin: 0pt;
              text-align: justify;
              text-indent: 21pt;
              line-height:28pt;
              widows: 0;
              font-family: 宋体;
              overflow: hidden;
              font-size: 14pt;
            "
            contenteditable
          >
            <span v-show="!isContent">我集团所属</span>
            <span v-show="!isContent">{{ item.companyName }}</span>
            <span v-show="!isContent">员工</span>
            <span v-show="!isContent">{{ item.leaderName }}</span>
            <span v-show="!isContent">等</span>
            <span v-show="!isContent">{{ item.num }}</span>
            <span v-show="!isContent">人目前在</span>
            <span v-show="!isContent">{{ item.visitCountry }}</span>
            <span v-show="!isContent">参与</span>
            <span v-show="!isContent">{{ item.taskTypeName }}</span>
            <span v-show="!isContent">
              。因项目任务需要,
            </span>
            <span v-show="!isContent">{{ item.leaderName }}</span>
            <span v-show="!isContent">等</span>
            <span v-show="!isContent">{{ item.num }}</span>
            <span v-show="!isContent">人</span>
            <span v-show="!isContent">仍需在</span>
            <span v-show="!isContent">{{ item.visitCountry }}</span>
            <span v-show="!isContent">常驻开展相关工作。</span>
            <span
              v-show="!isContent"
              style="font-size: 14pt;line-height: 28px;font-family: 宋体"
              >{{ item.passportMsg }}</span
            >
            <span
              v-show="!isContent"
              style="font-size: 14pt;line-height: 28px;font-family: 宋体;"
              >{{ item.passportVal }}</span
            >
            <span v-show="!isContent">,拟赴</span>
            <span v-show="!isContent">{{ item.consulates }}</span>
            <span v-show="!isContent">{{
              item.type == 1
                ? "换发护照"
                : item.type == 2
                ? "补发护照"
                : "申请旅行证"
            }}</span>
            <span v-show="!isContent">，现将申请报送贵处，请予协助办理。</span>
          </div>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 14pt">名单如下：</span>
          </p>
          <table
            cellspacing="0"
            cellpadding="0"
            class="person-table"
            style="
              border-collapse: collapse;
              margin-left: 21pt;
              width: 100%;
              margin-bottom: 10pt;
            "
            v-for="(row, index) in item.list"
            :key="'row__' + index"
          >
            <tr style="height: 31.5pt">
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 39.6pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                    >姓 名</span
                  >
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 60.05pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                    >出生日期</span
                  >
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 54pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                    >护照号码</span
                  >
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 60pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                    >有效期至</span
                  >
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 52.05pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                    >需办项目</span
                  >
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 109.7pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                    >办理原因</span
                  >
                </p>
              </td>
            </tr>
            <tr style="height: 33.75pt">
              <td
                colspan="6"
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 429.4pt;
                "
              >
                <p style="margin: 0pt">
                  <span
                    style="
                      font-family: 宋体;
                      font-size: 12pt;
                      font-weight: bold;
                    "
                  >
                    以下人员须在 {{ item.consulates }}
                    办理护照手续
                  </span>
                </p>
              </td>
            </tr>
            <tr
              style="height: 33.75pt"
              v-for="person in row"
              :key="person.personId + '_' + item.renewalId"
            >
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 39.6pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span style="font-family: 宋体; font-size: 12pt">{{
                    person.name
                  }}</span>
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 60.05pt;
                "
              >
                <p
                  style="margin: 0pt; orphans: 0; text-align: center; widows: 0"
                >
                  <span style="font-family: 宋体; font-size: 12pt">{{
                    person.birthday
                  }}</span>
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 54pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span style="font-family: 宋体; font-size: 12pt">{{
                    person.passportNo
                  }}</span>
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 60pt;
                "
              >
                <p
                  style="margin: 0pt; orphans: 0; text-align: center; widows: 0"
                >
                  <span style="font-family: 宋体; font-size: 12pt">{{
                    person.validityDate.slice( 0,10)
                  }}</span>
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 52.05pt;
                "
              >
                <p style="margin: 0pt; text-align: center">
                  <span style="font-family: 宋体; font-size: 12pt">{{
                    item.type == 1
                      ? "换发护照"
                      : item.type == 2
                      ? "补发护照"
                      : "申请旅行证"
                  }}</span>
                </p>
              </td>
              <td
                style="
                  border-bottom-color: #000000;
                  border-bottom-style: solid;
                  border-bottom-width: 0.75pt;
                  border-left-color: #000000;
                  border-left-style: solid;
                  border-left-width: 0.75pt;
                  border-right-color: #000000;
                  border-right-style: solid;
                  border-right-width: 0.75pt;
                  border-top-color: #000000;
                  border-top-style: solid;
                  border-top-width: 0.75pt;
                  padding-left: 5.03pt;
                  padding-right: 5.03pt;
                  vertical-align: middle;
                  width: 109.7pt;
                "
              >
                <p style="margin: 0pt; text-align: center; padding-top: 5pt;">
                  <textarea
                    name="textarea"
                    rows="2"
                    cols="20"
                    maxlength="20"
                    style="border:none;outline:none;font-family:宋体;font-size: 12pt;width: 100%;word-wrap:break-word;resize:none;"
                    v-model="person.reason"
                  ></textarea>
                </p>
              </td>
            </tr>
            <tr style="height: 0pt">
              <td style="width: 50.4pt; border: none"></td>
              <td style="width: 70.85pt; border: none"></td>
              <td style="width: 64.8pt; border: none"></td>
              <td style="width: 70.8pt; border: none"></td>
              <td style="width: 62.85pt; border: none"></td>
              <td style="width: 120.5pt; border: none"></td>
            </tr>
          </table>

          <p style="margin-top: 10pt; orphans: 0; text-align: right; widows: 0">
            <img
              src="./wanglei.png"
              style="vertical-aligen: middle; height: 60pt"
              alt
            />
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-align: right;
              widows: 0;
              font-family: 宋体;
              font-size: 14pt;
              font-weight: bold;
            "
          >
            <input
              type="text"
              style="outline:none;font-size: 14pt;border:none;text-align:center;margin:0 5pt 0 0;width: 33pt;font-weight:bold"
              v-model="editYear"
              @change="yearChange"
              id="print-year"
            />
            年
            <input
              type="text"
              style="outline:none;font-size: 14pt;border:none;text-align:center;margin:0 5pt 0 0;width: 20pt;font-weight:bold"
              v-model="editMonth"
              @change="monthChange"
              id="print-year"
            />
            月

            <input
              type="text"
              style="outline:none;font-size: 14pt;border:none;text-align:center;margin:0 5pt 0 0;width: 20pt;font-weight:bold"
              v-model="editDay"
              @change="dayChange"
            />
            日
            <!-- <span>{{ currentDate }}</span> -->
          </p>
          <p
            style="
              margin: 0pt;
              orphans: 0;
              text-indent: 20.6pt;
              widows: 0;
            "
          >
            <span style="font-family: 宋体; font-size: 14pt; font-weight: bold"
              >&#xa0;</span
            >
          </p>
          <p
            style="
              margin: 0 0 0 21pt;
              orphans: 0;
              text-align: justify;
              widows: 0;
              font-family: 宋体;
              font-size: 14pt;
              font-weight: bold;
            "
          >
            <span>联系人:</span>
            <input
              type="text"
              style="
                outline: none;
                font-size: 14pt;
                border: none;

                margin: 10pt 5pt 10pt 5pt;
                width: 60pt;
                font-weight: bold;
              "
              v-model="contact"
            />
            <br />
            <span>电话:</span>
            <input
              type="text"
              style="
                outline: none;
                font-size: 14pt;
                border: none;

                margin: 10pt 5pt 10pt 5pt;
                width: 185pt;
                font-weight: bold;
              "
              v-model="tel"
            />
            <br />
            <span>传真:</span>
            <input
              type="text"
              style="
                outline: none;
                font-size: 14pt;
                border: none;
                margin: 10pt 5pt 10pt 5pt;
                width: 110pt;
                font-weight: bold;
              "
              v-model="fax"
            />
          </p>
        </div>
        <div v-for="(scan, index) in item.oldScan" :key="index">
          <div
            :key="'scan_' + index"
            v-if="scan"
            :class="{ 'scal-wrap': true, 'page-break': index === 0 }"
            style="
                    width: 21cm;
                    margin: 0 auto;
                    height: 14.85cm;
                    padding: 0 1cm;
                    box-sizing: border-box;
                "
            :style="{ pageBreakAfter: getPageAfter(item, scan, index) }"
          >
            <img
              @click="showCut(scan, index)"
              style="max-width:100%;cursor: pointer;"
              title="点击可以裁剪"
              @error="errorHandler"
              :src="scan.url"
            />
            <!-- <img
                    v-if="scan"
                    @click="showCut(scan, index)"
                    style="max-width: 100%; max-height: 100%;cursor: pointer;"
                    title="点击可以裁剪"
                    :src="scan.url"
                /> -->
          </div>
        </div>
      </template>
    </div>
    <div style="text-align: center">
      <span
        >版权所有：中国化学工程集团(股份)有限公司 |
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >京ICP备17025820号-5</a
        >
        | 版本号：{{ this.versionNumber }}<!-- | 技术支持：北京赛鼎科技有限公司 --></span
      >
    </div>
    <el-dialog
      :visible.sync="visible"
      top="5vh"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-row type="flex" justify="space-around">
        <img-cutter
          ref="imgCutter"
          @cutDown="cutdownHandler"
          v-show="visible"
          box-height="600"
          :isModal="false"
        ></img-cutter>
      </el-row>
      <el-row slot="footer" type="flex" justify="space-around">
        <el-button type="primary" @click="confirmCut">确定裁剪</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import print from "print-js";
import DateUtils from "../../util/date";
import Api from "../../api/foreign/foreign_cancellation/exchange.js";
import { mapGetters } from "vuex";
import ImgCutter from "vue-img-cutter";
import _ from "lodash";
const curDate =
  new Date().getDate() >= 10
    ? new Date().getDate()
    : `0${new Date().getDate()}`;
const curMonth =
  new Date().getMonth() + 1 >= 10
    ? new Date().getMonth() + 1
    : `0${new Date().getMonth() + 1}`;
const curYear = new Date().getFullYear();
import encipherUtil from "@/util/encipher";
let encipher = new encipherUtil();
export default {
  name: "printExchange",
  components: {
    ImgCutter
  },
  props: {
    mode: {
      type: String,
      default: "PC"
    }
  },
  data() {
    return {
      info: [],
      dateList: [],
      contact: "庄静",
      tel: "59765667/13801358945",
      fax: "59765661",
      currentDate: "",
      inputWidth: 30,
      spanWidth: null,
      currentItem: null,
      currentIndex: null,
      passportVal: "",
      visible: false,
      currentYear: "",
      currentMonth: "",
      currentDay: "",
      oldYear: "",
      oldMonth: "",
      oldDay: "",
      editYear: curYear,
      editMonth: curMonth,
      month: "",
      editDay: curDate,
      isContent: null,
      buttonLoad: false,
      passportMsg: "由于因公护照"
    };
  },
  computed: {
    ...mapGetters(["token", "versionNumber"]),
    text() {
      return function(value) {
        let width = String(value).length * 15 + "pt";
        return width;
      };
    }
  },
  methods: {
    yearChange(e) {
      let reg = /^(19|20)[0-9]{2}$/;
      let str = reg.test(e.target.value);
      if (!str) {
        this.$message.error("输入的年份不合格，请重新输入");
        this.editYear = "";
      }
    },
    monthChange(e) {
      let reg = /^(0[1-9])|(1[0-2])$/;
      let str = reg.test(e.target.value);
      if (!str) {
        this.$message.error("输入的月份不合格，请重新输入");
        this.editMonth = "";
      }
    },
    dayChange(e) {
      let reg = /^(0[1-9])|(1[0-9])|(2[0-9])|(3[0-1])$/;
      let str = reg.test(e.target.value);
      if (!str) {
        this.$message.error("输入的日期不合格，请重新输入");
        this.editDay = "";
      }
    },
    changInputText(e) {
      this.passportVal = e.target.value;
      this.spanWidth = this.getInputWidth(e.target.value);
    },
    getInputWidth(value) {
      let width = `${String(value).length * 15}pt`;
      return width;
    },
    getPageAfter(item, scan, index) {
      return item.oldScan.some(el => el instanceof Object) &&
        index < item.oldScan.length - 1
        ? "always"
        : "avoid";
    },
    errorHandler(e) {
      this.$message.error("扫描件加载失败,请上传");
      e.target.src = require("../../assets/image/icons/图片加载失败.png");
      let span = document.createElement("span");
      span.className = "no-print";
      span.innerHTML = '<i class="el-icon-arrow-left"></i>点击重新上传扫描件';
      e.target.parentNode.appendChild(span);
    },
    printHandler() {
      let obj = {};
      this.$forceUpdate();
      let id = this.$route.query.id;
      obj = {
        renewalId: id,
        openTime: `${this.editYear}-${this.editMonth}-${this.editDay}`
      };
      Api.editOpenExchangeTime(obj);
      print({
        type: "html",
        printable: "print",
        scanStyles: false,
        style:
          ".no-print{display: none}.person-table+.person-table,.page-break{page-break-before: always}"
      });
    },
    saveHandler() {
      let allSpan = !this.isContent
        ? document.querySelectorAll(".letter-content span")
        : document.querySelectorAll(".show-content span");
      if (!allSpan.length) {
        allSpan = !this.isContent
          ? document.querySelectorAll(".letter-content")
          : document.querySelectorAll(".show-content");
      }
      let str = "";
      for (let i = 0; i < allSpan.length; i++) {
        str += allSpan[i].innerText;
      }
      let list = [];
      let personList = this.info[0].list[0];
      for (let j = 0; j < personList.length; j++) {
        let obj = {};
        obj.renewalUserId = personList[j].renewalUserId;
        obj.reason = personList[j].reason;
        list.push(obj);
      }

      let query = {
        renewalId: this.$route.query.id, //id
        letterContent: str, //内容
        openTime: `${this.editYear}-${this.editMonth}-${this.editDay}`, //函件日期
        letterContact: this.contact, //函件联系人
        letterPhone: this.tel, //函件电话
        letterFax: this.fax, //函件传真
        userModels: list
      };
      this.buttonLoad = true;
      Api.saveLetter(query)
        .then(res => {
          if (res.code == 1) {
            this.$message.success("保存成功");
            this.buttonLoad = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.buttonLoad = false;
        });
    },
    confirmCut() {
      this.$refs.imgCutter.cropPicture(false);
    },
    cutdownHandler(obj) {
      this.visible = false;
      this.$set(this.currentItem, "url", obj.dataURL);
    },
    showCut(item, index) {
      this.currentItem = item;
      this.currentIndex = index;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.imgCutter.handleOpen({
          name: item.origin,
          src: item.url
        });
      });
    },
    download(path) {
      let a = document.createElement("a");
      a.href = `/share-foreign/commannex/viewAnnex?token=${this.token}&path=${path}`;
      a.download = path.match(/annex\/\d+_(.*)/)[1];
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  },
  mounted() {
    this.dateList = JSON.parse(encipher.getSessionStorageAES("changeDateList"));
    if (this.dateList) {
      this.oldYear = this.dateList[0].year;
      this.oldMonth = this.dateList[0].month;
      this.oldDay = this.dateList[0].day;
    }
    if (this.$route.query.id) {
      this.$route.query.id.split(",").forEach(val => {
        Api.addGenerateLog({ id: val });
      });
      Promise.all(
        this.$route.query.id.split(",").map(a => {
          return Api.detail({ renewalId: a });
        })
      ).then(res => {
        this.info.push(
          ...res.map(a => {
            if (a.data.renewalPassportRsult) {
              this.isContent = a.data.renewalPassportRsult.letterContent
                ? a.data.renewalPassportRsult.letterContent
                : null;
              this.contact = a.data.renewalPassportRsult.letterContact
                ? a.data.renewalPassportRsult.letterContact
                : "庄静";
              this.tel = a.data.renewalPassportRsult.letterPhone
                ? a.data.renewalPassportRsult.letterPhone
                : "59765667/13801358945";
              this.fax = a.data.renewalPassportRsult.letterFax
                ? a.data.renewalPassportRsult.letterFax
                : "59765661";
              if (
                a.data.renewalPassportRsult &&
                a.data.renewalPassportRsult.openTime
              ) {
                this.editYear = a.data.renewalPassportRsult.openTime.substr(
                  0,
                  4
                );
                this.editMonth = a.data.renewalPassportRsult.openTime.substr(
                  5,
                  2
                );
                this.editDay = a.data.renewalPassportRsult.openTime.substr(8,2);
              } else {
                this.editYear = curYear;
                this.editMonth = curMonth;
                this.editDay = curDate;
              }
              a.data.renewalPassportRsult.oldScan = a.data.list
                .filter(a => a.oldScan)
                .map(a => {
                  return {
                    origin: a.oldScan,
                    url: `/share-foreign/commannex/viewAnnex?token=${this.token}&path=${a.oldScan}`
                  };
                });
              if (a.data.list.length <= 6) {
                a.data.renewalPassportRsult.list = _.chunk(a.data.list, 6);
              } else {
                let first = [a.data.list.splice(0, 12)];
                a.data.renewalPassportRsult.list = first.concat(
                  _.chunk(a.data.list, 20)
                );
              }
            }
            return a.data.renewalPassportRsult;
          })
        );
        this.info.forEach((item, index, arr) => {
          arr[index].passportMsg = `由于因公`;
          arr[index].passportVal = `护照${
            item.reasonType == 1
              ? "失效"
              : item.reasonType == 2
              ? "丢失"
              : item.reasonType == 4
              ? "有效期不足"
              : item.reasonType == 5
              ? item.otherReason
              : "损毁"
          },同时为满足工作签证延续要求`;
        });
      });
      this.currentDate = new DateUtils().format(new Date(), "yyyy年MM月dd日");
      this.currentYear = new DateUtils().format(new Date(), "yyyy");
      this.currentMonth = new DateUtils().format(new Date(), "MM");
      this.currentDay = new DateUtils().format(new Date(), "dd");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style/note.scss";
#app {
  overflow: scroll !important;
}
input[type="text"] {
  border-bottom: 1pt solid #000 !important;
}
</style>
